import Vue from 'vue'
import Router from 'vue-router'
import StairLayout from '@/views/layout/StairLayout.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {path: '/login', component: () => import('@/views/login/index')},
    {path: '/bindingLogin', component: () => import('@/views/login/bindingLogin')},
    {path: '/autoLogin', component: () => import('@/views/login/autoLogin')},
    {
      path: '/rent',
      name: 'transfer',
      meta: {
        title: '正在跳转',
        index: 1,
        tabbar: false,
        titleBar: false
      },
      component: () => import('@/views/transfer/index')
    },

    {
      path: '/',
      name: 'author',
      redirect: '/home',
      component: StairLayout,
      children: [
        {
          path: 'bindingMobile',
          name: 'bindingMobile',
          meta: {
            title: '绑定手机',
            index: 3,
            tabbar: false,
            titleBar: false
          },
          component: () => import('@/views/login/bindingMobile')
        },
        {
          path: 'test',
          name: 'test',
          meta: {
            title: '测试',
            index: 1,
            tabbar: true,
            titleBar: true
          },
          component: () => import('@/views/test/index')
        },
        {
          path: 'home',
          name: 'home',
          meta: {
            title: '首 页',
            index: 1,
            tabbar: true,
            titleBar: false
          },
          component: () => import('@/views/home/index')
        },
        {
          path: 'user',
          name: 'user',
          meta: {
            title: '我 的',
            index: 2,
            tabbar: true,
            titleBar: false
          },
          component: () => import('@/views/user/index')
        }
      ]
    },
    //
    {
      path: '/article',
      name: 'article',
      redirect: '/article/list',
      component: StairLayout,
      children: [
        {
          path: 'list',
          name: 'list',
          meta: {
            title: '列 表',
            index: 4,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/article/list')
        },
        {
          path: 'articleDetail',
          name: 'articleDetail',
          meta: {
            title: '详情',
            index: 5,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/article/articleDetail')
        },
      ]
    },
    {
      path: '/equipment',
      name: 'author',
      redirect: '/equipment/rent',
      component: StairLayout,
      children: [
        {
          path: 'orderMain',
          name: 'orderMain',
          meta: {
            title: '订单',
            index: 3,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/equipment/orderMain/index')
        },
        {
          path: 'rent',
          name: 'rent',
          meta: {
            title: '租赁订单',
            index: 3,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/equipment/rent/index')
        },
        {
          path: '/rentDetail',
          name: 'rentDetail',
          component: () => import('@/views/equipment/rent/detail')
        },
        {
          path: 'renewal',
          name: 'renewal',
          meta: {
            title: '续 租',
            index: 3,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/equipment/renewal/index')
        },
        {
          path: 'renewalDetail',
          name: 'renewalDetail',
          meta: {
            title: '续租详情',
            index: 4,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/equipment/renewal/detail')
        },
        {
          path: 'changeDetail',
          name: 'changeDetail',
          meta: {
            title: '换寝详情',
            index: 4,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/equipment/change/detail')
        },
        {
          path: 'repair',
          name: 'repair',
          meta: {
            title: '维 修',
            index: 3,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/equipment/repair/index')
        },
        {
          path: 'repairDetail',
          name: 'repairDetail',
          meta: {
            title: '维修详情',
            index: 4,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/equipment/repair/detail')
        },
        {
          path: 'refund',
          name: 'refund',
          meta: {
            title: '退 租',
            index: 3,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/equipment/refund/index')
        },
        {
          path: 'refundDetail',
          name: 'refundDetail',
          meta: {
            title: '退租详情',
            index: 4,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/equipment/refund/detail')
        },
        {
          path: 'control',
          name: 'equipmentControl',
          meta: {
            title: '智能空调',
            index: 4,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/equipmentControl/index')
        },
        {
          path: 'payResult',
          name: 'payResult',
          meta: {
            title: '支付结果',
            index: 1,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/equipment/rent/resultPage.vue')
        },
      ]
    },
    {
      path: '/userIn',
      name: 'userIn',
      redirect: '/userIn/userInfo',
      component: StairLayout,
      children: [
        {
          path: 'userInfo',
          name: 'userInfo',
          meta: {
            title: '学生信息',
            index: 3,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/user/userInfo/index')
        },
        {
          path: 'userOrder',
          name: 'userOrder',
          meta: {
            title: '合同',
            index: 3,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/user/userOrder/index')
        },
        {
          path: 'userChangeRoom',
          name: 'userChangeRoom',
          meta: {
            title: '更换寝室',
            index: 4,
            tabbar: false,
            titleBar: false
          },
          component: () => import('@/views/user/userOrder/components/changeRoom.vue')
        },
        {
          path: 'orderDetails',
          name: 'orderDetails',
          meta: {
            title: '合同详情',
            index: 4,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/user/userOrder/orderDetails')
        },
        {
          path: 'repairDetails',
          name: 'repairDetails',
          meta: {
            title: '续租详情',
            index: 4,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/user/userOrder/repairDetails')
        },
        {
          path: 'userTicket',
          name: 'userTicket',
          meta: {
            title: '优惠中心',
            index: 3,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/user/userTicket/index')
        },
        {
          path: 'userAddress',
          name: 'userAddress',
          meta: {
            title: '我的地址',
            index: 4,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/user/userAddress/index')
        },
        {
          path: 'userContact',
          name: 'userContact',
          meta: {
            title: '成员信息',
            index: 3,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/user/userContact/index')
        },
        {
          path: 'about',
          name: 'about',
          meta: {
            title: '关于我们',
            index: 3,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/user/about/index')
        },
        {
          path: 'help',
          name: 'help',
          meta: {
            title: '帮助说明',
            index: 3,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/user/help/index')
        },
        {
          path: 'article',
          name: 'article',
          meta: {
            title: '协议条款',
            index: 3,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/user/help/articleDetail')
        },
        {
          path: 'balanceUseDetail',
          name: 'balanceUseDetail',
          meta: {
            title: '余额使用明细',
            index: 3,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/user/balanceUseDetail/index')
        }
      ]
    },
    {
      path: '/advance',
      name: 'advance',
      redirect: '/advance/manage',
      component: StairLayout,
      children: [
        {
          path: 'manage',
          name: 'manage',
          meta: {
            title: '预收',
            index: 3,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/advance/manage/index')
        },
        {
          path: 'advanceDetail',
          name: 'advanceDetail',
          meta: {
            title: '预收详情',
            index: 4,
            tabbar: false,
            titleBar: true
          },
          component: () => import('@/views/advance/manage/detail')
        },
      ]
    },
    {path: '*', component: () => import('@/views/errorPage/404')}
  ]
})
